import { Grid, Typography } from "@mui/material"
import FacilitiesList from "./FacilitiesList"
import { BarChartPopulation } from "./BarChartPopulation"

const ManagingFacilityView = ({
  mode,
  cup_geo_json,
  current_id,
  fac_geo_json,
  card_facilities,
}) => {
  if (mode !== "cups") {
    return null
  }
  const managing_fac_id = cup_geo_json?.features.find(
    (feature) => feature.id === current_id
  )?.properties?.managing_fac_id

  let name
  if (managing_fac_id) {
    name = fac_geo_json.features.find(
      (feature) => feature.id === managing_fac_id
    ).properties.name
  } else {
    const { district, regional, chc } = card_facilities
    if (district && district.length >= 0) {
      name = district[0]
    } else if (regional && regional.length >= 0) {
      name = regional[0]
    } else if (chc && chc >= 0) {
      name = chc[0]
    } else {
      name = "None"
    }
  }

  return (
    <div>
      <Typography variant="h7">Managing Facility: </Typography>
      {name}
      <br />
      <br />
    </div>
  )
}

export default function Stats({
  mode,
  current_stats,
  card_facilities,
  cup_geo_json,
  current_id,
  fac_geo_json,
}) {
  return (
    <div>
      <ManagingFacilityView
        mode={mode}
        cup_geo_json={cup_geo_json}
        current_id={current_id}
        card_facilities={card_facilities}
        fac_geo_json={fac_geo_json}
      />
      <Grid
        container
        style={{
          width: "100%",
          height: mode === "districts" ? 280 : 240,
        }}
      >
        <Grid item xs={5} style={{ width: "100%", height: "100%" }}>
          {current_stats ? <BarChartPopulation data={current_stats} /> : null}
        </Grid>
        <Grid item xs={7} style={{ borderLeft: 1 }}>
          {card_facilities ? (
            <FacilitiesList
              hospitals_in_current_study_area={card_facilities}
              study_area={mode}
            />
          ) : null}
        </Grid>
      </Grid>
    </div>
  )
}
